import { motion } from "framer-motion";
import { useLang } from "@/lib/i18n";

export default function Stats() {
  const { t } = useLang();
  return (
    <section data-testid="stats-section" className="border-y border-white/10 bg-[#0F1115]">
      <div className="mx-auto grid max-w-[1400px] grid-cols-2 lg:grid-cols-4">
        {t.stats.map((s, i) => (
          <motion.div
            key={s.l}
            data-testid={`stat-item-${i}`}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 0.8, delay: i * 0.1, ease: [0.16, 1, 0.3, 1] }}
            className={`group relative overflow-hidden px-5 py-10 sm:px-8 sm:py-14 ${i % 2 ? "border-l border-white/10" : ""} ${i > 1 ? "border-t border-white/10 lg:border-t-0" : ""} ${i === 2 ? "lg:border-l" : ""}`}
          >
            <span className="absolute inset-x-0 bottom-0 h-0.5 origin-left scale-x-0 bg-white transition-transform duration-700 group-hover:scale-x-100" />
            <p className="font-display text-4xl font-black italic text-white sm:text-6xl">{s.v}</p>
            <p className="mt-3 max-w-[16rem] font-mono-tc text-xs uppercase tracking-[0.15em] text-zinc-400">{s.l}</p>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
